import { format, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { PLACEHOLDER } from 'src/pages/Operation/OperationDebentures/OperationDebenturesGeneralData/utils';
import { formatAmountBRL } from 'src/utils/number';

export { PLACEHOLDER };

export function formatLiabilityText(value?: string | null): string {
  return value ?? PLACEHOLDER;
}

export function formatLiabilityCurrency(value?: number | null): string {
  if (value === null || value === undefined) return PLACEHOLDER;
  return formatAmountBRL(value);
}

export function isNegativeLiabilityValue(value?: number | null): boolean {
  return value !== null && value !== undefined && value < 0;
}

export function formatLiabilityCategoryCurrency(value?: number | null): string {
  if (value === null || value === undefined) return PLACEHOLDER;
  if (value < 0) {
    return `(${formatAmountBRL(Math.abs(value))})`;
  }
  return formatAmountBRL(value);
}

export function formatLiabilityQuantity(value?: number | null): string {
  if (value === null || value === undefined) return PLACEHOLDER;
  return value.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
}

export function formatLiabilityDecimal(value?: number | null): string {
  if (value === null || value === undefined) return PLACEHOLDER;
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
}

export function formatLiabilityDate(dateStr?: string | null): string {
  if (!dateStr) return PLACEHOLDER;

  try {
    return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', {
      locale: ptBR,
    });
  } catch {
    return dateStr;
  }
}

export function formatLiabilityCompetence(competencia?: string | null): string {
  return competencia ?? PLACEHOLDER;
}
